/* Lindea – Bundle: Auswahl, Preise, Farbe & Größe je Stück, In den Warenkorb */
(function () {
  'use strict';
  if (customElements.get('lindea-bundle')) return;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var map = {
      amount: withComma + '.' + parts[1],
      amount_no_decimals: withComma,
      amount_with_comma_separator: withDot + ',' + parts[1],
      amount_no_decimals_with_comma_separator: withDot
    };
    return (format || '{{amount_with_comma_separator}}€').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return map[k] != null ? map[k] : map.amount; });
  }

  customElements.define('lindea-bundle', class extends HTMLElement {
    connectedCallback() {
      try { this.product = JSON.parse(this.querySelector('[data-lx-product]').textContent); } catch (e) { return; }
      this.format = this.dataset.moneyFormat;
      this.form = document.getElementById(this.dataset.formId);
      this.opts = Array.prototype.slice.call(this.querySelectorAll('.lx-bundle__opt'));
      this.err = this.querySelector('.lx-bundle__error');

      this.opts.forEach((opt) => {
        opt.querySelector('input').addEventListener('change', () => this.select(opt));
        opt.querySelectorAll('select').forEach((s) => {
          s.addEventListener('click', (e) => e.stopPropagation());
          s.addEventListener('change', () => { s.dataset.touched = '1'; this.hideError(); });
        });
      });
      if (!this.selected()) this.select(this.opts[0]);

      // Hauptauswahl (Farbe/Größe oben) -> alle noch nicht geänderten Stücke übernehmen
      this.onMainChange = () => setTimeout(() => this.syncFromMain(), 60);
      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('variant-selects, variant-radios') && !this.contains(e.target)) this.onMainChange();
      });

      // Formular abfangen (auch Sticky-Button, der dasselbe Formular nutzt)
      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);
    }

    selected() { return this.opts.find((o) => o.classList.contains('is-selected')); }

    select(opt) {
      if (!opt) return;
      this.opts.forEach((o) => { o.classList.toggle('is-selected', o === opt); o.querySelector('input').checked = o === opt; });
      this.hideError();
      var qtyInput = this.form && this.form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = opt.dataset.qty;
    }

    mainVariant() {
      var input = this.form && this.form.querySelector('[name="id"]');
      var id = input ? parseInt(input.value, 10) : 0;
      return this.product.variants.find((v) => v.id === id) || this.product.variants[0];
    }

    syncFromMain() {
      var v = this.mainVariant();
      if (!v) return;
      this.querySelectorAll('[data-lx-piece]').forEach((piece) => {
        piece.querySelectorAll('select').forEach((s) => {
          if (s.dataset.touched) return;
          var val = v.options[parseInt(s.dataset.lxOpt, 10)];
          if (val != null && s.value !== val) s.value = val;
        });
      });
      this.opts.forEach((o) => {
        var qty = parseInt(o.dataset.qty, 10), off = parseInt(o.dataset.off, 10) || 0;
        var p = o.querySelector('[data-lx-price]');
        if (p) p.textContent = formatMoney(Math.max(0, v.price * qty - off), this.format);
        var c = o.querySelector('[data-lx-cmp]');
        if (c) c.textContent = formatMoney(v.price * qty, this.format);
      });
    }

    pieceVariant(piece) {
      var values = Array.prototype.map.call(piece.querySelectorAll('select'), (s) => s.value);
      return this.product.variants.find((v) => v.options.every((o, i) => o === values[i]));
    }

    buildItems() {
      var opt = this.selected();
      var qty = parseInt(opt.dataset.qty, 10) || 1;
      var counts = {};
      var pieces = opt.querySelectorAll('[data-lx-piece]');
      if (this.dataset.pickers && pieces.length) {
        for (var i = 0; i < pieces.length; i++) {
          var v = this.pieceVariant(pieces[i]);
          if (!v || !v.available) return { error: 'Stück #' + (i + 1) + ': Diese Kombination ist leider nicht verfügbar.' };
          counts[v.id] = (counts[v.id] || 0) + 1;
        }
      } else {
        var mv = this.mainVariant();
        if (!mv || !mv.available) return { error: 'Diese Variante ist leider nicht verfügbar.' };
        counts[mv.id] = qty;
      }
      return { items: Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id] })) };
    }

    onSubmit(e) {
      if (!this.form || e.target !== this.form || !this.isConnected) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var built = this.buildItems();
      if (built.error) return this.showError(built.error);

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      // Achtung: form.id wäre hier das Feld name="id" – deshalb die ID aus data-form-id
      var fid = this.dataset.formId;
      var buttons = Array.prototype.slice.call(this.form.querySelectorAll('button[type="submit"]'))
        .concat(Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + fid + '"]')));
      buttons.forEach((b) => { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });

      var body = { items: built.items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status && res.description) return this.showError(res.description);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lindea-bundle', cartData: res });
          if (cart && cart.renderContents) {
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => this.showError('Etwas ist schiefgelaufen. Bitte versuche es erneut.'))
        .finally(() => buttons.forEach((b) => { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); }));
    }

    showError(msg) { if (this.err) { this.err.textContent = msg; this.err.hidden = false; } }
    hideError() { if (this.err) this.err.hidden = true; }
  });
})();
